/*
 * @Author: 肖玲
 * @Date: 2023-03-01 13:42:13
 * @LastEditTime: 2023-12-11 11:38:43
 * @LastEditors: 肖玲
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\butterfly-flow-system\alias-manage\modules\aliasLibraryRouter.js
 * 别名库
 */
import store from '@/store'
import { getAuthClientList } from '@/api/common'
const aliasLibraryRouter = [
  // 产品别名库
  {
    path: '/flowSystem/goods-alias',
    name: 'flowSystemGoodsAlias',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystem1" */
      //   '@/views/flowSystem/dataHandling/GoodsAlias.vue'
      // ),  待删除文件
      import(
        /*webpackChunkName:"flowSystem1" */
        '@/views/butterfly-flow-system/alias-manage/alias-library/product-alias-library/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '别名库', //二级菜单
      title: '产品别名库',
    },
  },
  // 产品别名库导入
  {
    path: '/flowSystem/goods-alias-import',
    name: 'flowSystemGoodsAliasImport',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystem1" */
      //   '@/views/flowSystem/dataHandling/GoodsAliasImport.vue'
      // ),  待删除文件
      import(
        /*webpackChunkName:"flowSystem1" */
        '@/views/butterfly-flow-system/alias-manage/alias-library/product-alias-library/Import.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '别名库', //二级菜单
      title: '导入产品别名',
      breadcrumb: [
        {
          title: '产品别名库',
          name: 'flowSystemGoodsAlias',
        },
      ],
    },
  },
  // 产品别名库-产品关键字设置
  {
    path: '/flowSystem/product-matching-settings',
    name: 'flowSystemGoodsAliasProductMatchingSettings',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystem1" */
      //   '@/views/flowSystem/dataHandling/ProductMatchingSettings.vue'
      // ),待删除文件
      import(
        /*webpackChunkName:"flowSystem1" */
        '@/views/butterfly-flow-system/alias-manage/alias-library/product-alias-library/KeyWordSet.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '别名库', //二级菜单
      title: '产品关键字设置',
      breadcrumb: [
        {
          title: '产品别名库',
          name: 'flowSystemGoodsAlias',
        },
      ],
    },
  },
  // 产品别名详情
  {
    path: '/flowSystem/goods-alias-details/:id',
    name: 'flowSystemGoodsAliasDetails',
    component: () =>
      // import('@/views/flowSystem/dataHandling/GoodsAliasDetails.vue'),待删除文件
      import(
        '@/views/butterfly-flow-system/alias-manage/alias-library/product-alias-library/Detail.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '别名库', //二级菜单
      title: '产品别名详情',
      breadcrumb: [
        {
          title: '产品别名库',
          name: 'flowSystemGoodsAlias',
        },
      ],
    },
  },
  // 产品别名库导出
  {
    path: '/flowSystem/goods-alias-export',
    name: 'flowSystemGoodsAliasExport',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystem1" */
      //   '@/views/flowSystem/dataHandling/GoodsAliasExport.vue'
      // ),  待删除文件
      import(
        /*webpackChunkName:"flowSystem1" */
        '@/views/butterfly-flow-system/alias-manage/alias-library/product-alias-library/Export.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '别名库', //二级菜单
      title: '导出产品别名',
      breadcrumb: [
        {
          title: '产品别名库',
          name: 'flowSystemGoodsAlias',
        },
      ],
    },
  },
  // 别名库删除   1：档案    2：产品
  {
    path: '/flowSystem/goods-alias-del/:type',
    name: 'flowSystemAliasDel',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystem1" */
      //   '../views/flowSystem/dataHandling/AliasDel.vue'
      // ), 待删除文件
      import(
        /*webpackChunkName:"flowSystem1" */
        '@/views/butterfly-flow-system/alias-manage/alias-library/product-alias-library/Delete.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '别名库', //二级菜单
      1: {
        title: '批量删除',
        breadcrumb: [
          {
            title: '档案别名库',
            name: 'flowSystemClientAlias',
          },
        ],
      },
      2: {
        title: '批量删除',
        breadcrumb: [
          {
            title: '产品别名库',
            name: 'flowSystemGoodsAlias',
          },
        ],
      },
    },
  },
  // 档案别名库|产品别名库 操作日志
  {
    path: '/flowSystem/alias-operation-log/:type',
    name: 'flowSystemClientAliasOperationLog',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystem2" */
      //   '../views/flowSystem/dataHandling/aliasOperationLog.vue'
      // ),待删除文件
      import(
        /*webpackChunkName:"flowSystem2" */
        '@/views/butterfly-flow-system/alias-manage/alias-library/product-alias-library/OprationLog.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '别名库', //二级菜单
      1: {
        title: '操作日志',
        breadcrumb: [
          {
            title: '档案别名库',
            name: 'flowSystemClientAlias',
          },
        ],
      },
      2: {
        title: '操作日志',
        breadcrumb: [
          {
            title: '产品别名库',
            name: 'flowSystemGoodsAlias',
          },
        ],
      },
    },
  },
  // 档案别名库
  {
    path: '/flowSystem/client-alias',
    name: 'flowSystemClientAlias',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystem2" */
      //   '@/views/flowSystem/dataHandling/ClientAlias.vue'
      // ),  待删除文件
      import(
        /*webpackChunkName:"flowSystem2" */
        '@/views/butterfly-flow-system/alias-manage/alias-library/archive-alias-library/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '别名库', //二级菜单
      title: '档案别名库',
    },
    beforeEnter(to, from, next) {
      getAuthClientList([1, 2, 3, 4, 7]).then((res) => {
        if (0 === res.status) {
          let classList = res.data.classList
          store.commit('setClientClassList', classList)
        }
        next()
      })
    },
  },
  // 档案别名库导入
  {
    path: '/flowSystem/client-alias-import',
    name: 'flowSystemClientAliasImport',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystem2" */
      //   '../views/flowSystem/dataHandling/ClientAliasImport.vue'
      // ),  待删除文件
      import(
        /*webpackChunkName:"flowSystem2" */
        '@/views/butterfly-flow-system/alias-manage/alias-library/archive-alias-library/Import.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '别名库', //二级菜单
      title: '档案别名库导入',
      breadcrumb: [
        {
          title: '档案别名库',
          name: 'flowSystemClientAlias',
        },
      ],
    },
  },
  // 档案别名详情
  {
    path: '/flowSystem/client-alias-details/:id',
    name: 'flowSystemClientAliasDetails',
    component: () =>
      // import('../views/flowSystem/dataHandling/ClientAliasDetails.vue'), 待删除文件
      import(
        '@/views/butterfly-flow-system/alias-manage/alias-library/archive-alias-library/Detail.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '别名库', //二级菜单
      title: '档案别名详情',
      breadcrumb: [
        {
          title: '档案别名库',
          name: 'flowSystemClientAlias',
        },
      ],
    },
  },
  // 档案别名库导出
  {
    path: '/flowSystem/client-alias-export',
    name: 'flowSystemClientAliasExport',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystem2" */
      //   '../views/flowSystem/dataHandling/ClientAliasExport.vue'
      // ),  待删除文件
      import(
        /*webpackChunkName:"flowSystem2" */
        '@/views/butterfly-flow-system/alias-manage/alias-library/archive-alias-library/Export.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '别名库', //二级菜单
      title: '档案别名库导出',
      breadcrumb: [
        {
          title: '档案别名库',
          name: 'flowSystemClientAlias',
        },
      ],
    },
  },

  
  // 批号别名库
  {
    path: '/flowSystem/batch-alias/page',
    name: 'flowSystemBatchAlias',
    component: () =>
      import(
        /*webpackChunkName:"flowSystem2" */
        '@/views/butterfly-flow-system/alias-manage/alias-library/batch-alias-library/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '别名库', //二级菜单
      title: '批号别名库',
    },
  },
  
  // 批号别名库 导入
  {
    path: '/flowSystem/batch-alias/import',
    name: 'flowSystemBatchAliasImport',
    component: () =>
      import(
        /*webpackChunkName:"flowSystem2" */
        '@/views/butterfly-flow-system/alias-manage/alias-library/batch-alias-library/Import.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '别名库', //二级菜单
      title: '批量操作批号别名',
      breadcrumb: [
        {
          title: '批号别名库',
          name: 'flowSystemBatchAlias',
        },
      ],
    },
  },


]
export default aliasLibraryRouter
